import { t } from 'i18next';
import PageLayout from 'src/app/components/PageLayoutComponent/PageLayout';
import { ICustomTabs } from 'src/app/components/TabLayoutComponent/tab-layout.config';
import TabLayout from 'src/app/components/TabLayoutComponent/TabLayout';
import { getPermissionKey } from 'src/app/helpers/permission.helper';
import UserRights from 'src/app/pages/AdministrationPage/UserRights/UserRights';
import UserRoles from 'src/app/pages/AdministrationPage/UserRoles/UserRoles';
import { routes } from 'src/configs/permissions.dictionary';

const AdministrationPage = () => {
  const tabItems: ICustomTabs[] = [
    {
      key: '1',
      label: t('administrationPage.userRoles.tabName'),
      children: <UserRoles />,
      permission: getPermissionKey([routes['/Administration'], 'UserRoles']),
    },
    {
      key: '2',
      label: t('administrationPage.userRights.tabName'),
      children: <UserRights />,
      permission: getPermissionKey([routes['/Administration'], 'UserRights']),
    },
  ];

  return (
    <PageLayout title={t('header.menu.administration')}>
      <TabLayout paramName="subTab" items={tabItems} />
    </PageLayout>
  );
};

export default AdministrationPage;
